import { useCallback } from "react";
import { useGo } from "@refinedev/core";
import { NOTIFICATIONS_EVENT_TYPE } from "store/websocketStore";
import type { LiveNotification } from "./useLiveNotifications";
import {
  getChatHistoryPath,
  getProjectAddonsAnalyticsPath,
  getProjectAnalyticsPath,
} from "../helpers/notifications";

/**
 * Navigates to the page a bell notification points at: the chat history for
 * chatbot questions, the add-ons analytics for quiz submissions, the
 * experience analytics otherwise.
 */
export function useOpenNotification(): {
  openNotification: (notification: LiveNotification) => void;
} {
  const go = useGo();

  const openNotification = useCallback(
    (notification: LiveNotification) => {
      if (notification.type === NOTIFICATIONS_EVENT_TYPE.QuizSubmitted) {
        go({ to: getProjectAddonsAnalyticsPath(notification.projectId) });
        return;
      }

      if (
        notification.type !== NOTIFICATIONS_EVENT_TYPE.ChatbotMessageAnswered
      ) {
        go({ to: getProjectAnalyticsPath(notification.projectId) });
        return;
      }

      go({ to: getChatHistoryPath(notification.projectId) });
    },
    [go]
  );

  return { openNotification };
}
